import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useListBrowserUtils } from '@ts-private/list-browser';
import { dictionaryDetailsStore } from './DictionaryDetailListBrowser';
import { useTranslation } from 'react-i18next';
import { TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { RoundedHeaderTableRow, ThemedHeaderTableCell } from 'components/common/table/TableStyles';
import WrappedFakeText from 'components/common/WrappedFakeText';
import DictionaryDetailListComponent from './DictionaryDetailListComponent';
import { DictionaryDetailTable, DictionaryDetailTableContainer } from './Styles';

const DictionaryDetailListContainer = ({ dictionary, withDictionaryItem }) => {
  const { t } = useTranslation();
  const { store } = useListBrowserUtils(dictionaryDetailsStore);

  const columns = useMemo(() => {
    const result = [{ caption: t('Dictionaries.DictionaryItem.Code'), width: '20%' }, { caption: t('Dictionaries.DictionaryItem.Name') }];
    if (!withDictionaryItem) {
      result.push(
        ...[
          { caption: t('Dictionaries.DictionaryItem.Description') },
          { caption: t('Dictionaries.DictionaryItem.OrderNo'), width: '10%' },
          { caption: t('Dictionaries.DictionaryItem.Implicit'), align: 'center', width: '10%' }
        ]
      );
    }
    result.push({ caption: t('Dictionaries.DictionaryItem.IsActive'), align: 'center', width: '10%' });
    return result;
  }, [t, withDictionaryItem]);

  const loading = useMemo(() => !store.initialized || store.loading, [store.initialized, store.loading]);

  return (
    <DictionaryDetailTableContainer mt={2}>
      <DictionaryDetailTable>
        <TableHead>
          <RoundedHeaderTableRow>
            {columns.map((column, index) => (
              <ThemedHeaderTableCell key={`${index}-${column}`} align={column.align} title={column.caption} width={column.width}>
                {column.caption}
              </ThemedHeaderTableCell>
            ))}
          </RoundedHeaderTableRow>
        </TableHead>
        <TableBody>
          {loading && (
            <TableRow>
              <TableCell colSpan={columns.length}>
                <WrappedFakeText />
              </TableCell>
            </TableRow>
          )}
          {!loading && (
            <DictionaryDetailListComponent dictionary={dictionary} withDictionaryItem={withDictionaryItem} columnsLength={columns.length} />
          )}
        </TableBody>
      </DictionaryDetailTable>
    </DictionaryDetailTableContainer>
  );
};

DictionaryDetailListContainer.propTypes = {
  dictionary: PropTypes.object,
  withDictionaryItem: PropTypes.bool
};

export default DictionaryDetailListContainer;
